module.exports = __webpack_public_path__ + "img/officialAccount.e56d7aa8.png";